import { ChangeDetectionStrategy, Component } from '@angular/core';
import { PageLayoutComponent, TitileNavbarComponent } from '@ui-components';
import { HostedInvitationsListComponent } from '@invitations';

@Component({
  templateUrl: './invite-players.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [TitileNavbarComponent, HostedInvitationsListComponent, PageLayoutComponent]
})
export class InvitePlayersComponent {}
